import { useEffect, useState, useCallback } from 'react'
import { createOrderCameViaReplaceStorageKey, intendedOrderTypeStorageKey, returnAfterAuthStorageKey } from 'routes/url-constants'
import { getCsrf, getSession, refreshToken } from '../requests/auth'

export function useAuth() {
  const [session, setSession] = useState<any>(null)
  const [loading, setLoading] = useState(true)
  const [csrf, setCsrf] = useState<string>('')

  useEffect(() => {
    ;(async () => {
      const csrfData = await getCsrf()
      setCsrf(csrfData.csrf)

      try {
        const sessionData = await getSession()
        setSession(sessionData || null)
      } catch (e) {
        console.log(e.message)
      }

      setLoading(false)
    })()
  }, [])

  const refresh = useCallback(async () => {
    await refreshToken(csrf)
    try {
      const sessionData = await getSession()
      setSession(sessionData || null)
    } catch (e) {
      console.log(e.message)
    }
    return true
  }, [csrf])

  const logout = useCallback(() => {
    const form = document.createElement('form')
    form.action = `${process.env.REACT_APP_V3_SERVER}/auth/logout-all`
    form.method = 'GET'
    form.innerHTML = `<input type="hidden" name="csrf" value="${csrf}" />`
    document.body.append(form)

    localStorage.removeItem('token')
    localStorage.removeItem('login')
    localStorage.removeItem('role')
    localStorage.removeItem('name')
    sessionStorage.removeItem(createOrderCameViaReplaceStorageKey)
    sessionStorage.removeItem(returnAfterAuthStorageKey)
    sessionStorage.removeItem(intendedOrderTypeStorageKey)

    form.submit()
  }, [csrf])

  return { session, loading, refresh, csrf, logout }
}
